import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

function Card({ className, children }) {
  return (
    <div className={cn('p-6 bg-white drop-shadow rounded-lg', className)}>
      {children}
    </div>
  );
}

Card.defaultProps = {
  className: '',
};

Card.propTypes = {
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Card;
